'use client'
import { TypeCmsVariant } from '@/schema'
import { memo, useMemo } from 'react'
import type { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'

interface IRadioCheckBoxes {
  data: {
    variant: {
      bigcommerceId: number | string
    }
    currentVariantId: number | string
    setCurrentVariant: Dispatch<SetStateAction<TypeCmsVariant>>
    text: string
  }[]
}

const getRadioCheckBoxes = (variants) => variants?.map((data, idx) => {
  if(!data ) return null
  const { variant: { bigcommerceId:variantId }, currentVariantId, setCurrentVariant, text } = data
  return (
    <div key={idx + variantId}>
      <input id={variantId} onChange={() => {
        setCurrentVariant(data.variant)
      }} type='radio' checked={variantId === currentVariantId} />
      <span></span>
      <label htmlFor={variantId}>{text}</label>
    </div>
  )}
)

export const RadioCheckBoxes = memo<IRadioCheckBoxes>(({ data }) => {
  const InputRadios = useMemo(() => getRadioCheckBoxes(data), [data])

  if(!data)  return <></>
  return (
    <RadioButtonWrapper>
      {InputRadios}
    </RadioButtonWrapper>
  )
})

const RadioButtonWrapper = styled.div`
  span {
    align-items: center;
    background-color: var(--color-text);
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
    display: flex;
    height: 27px;
    justify-content: center;
    margin-right: 10px;
    pointer-events: none;
    position: relative;
    user-select: none;
    width: 25px;

    &:before {
      background-color: var(--color-white);
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
      content: ' ';
      display: none;
      height: 24px;
      width: 22px;
    }

    &:after {
      background-color:  var(--color-white);
      border-radius: 50%;
      content: ' ';
      height: 10px;
      position: absolute;
      width: 10px;
    }
  }

  label {
    white-space: nowrap;
    cursor: pointer;
  }

  input:not(:checked) + span::before {
    display: block;
  }
`
